// buildMissionWorkspaceCommandPreview.js — plain-English preview for agentic mission commands

function cleanString(value) {
  return String(value || '').trim();
}

function normalizeLabel(value) {
  return cleanString(value).toLowerCase();
}

function findField(fields, matcher) {
  return (Array.isArray(fields) ? fields : []).find((field) => matcher(field)) || null;
}

export function buildMissionWorkspaceCommandPreview({
  command = '',
  typeLabel = 'this record',
} = {}) {
  const text = cleanString(command);
  if (!text) {
    return 'When this task runs, an Agent will execute your command on this record.';
  }

  if (/\bcreate\b/i.test(text)) {
    return `When this task runs, an Agent will create a related record linked to ${typeLabel}.`;
  }

  if (/\b(?:set|update|change|mark)\b/i.test(text)) {
    return `When this task runs, an Agent will update ${typeLabel}.`;
  }

  return `When this task runs, an Agent will run your command on ${typeLabel}.`;
}

export function buildMissionWorkspaceCommandSuggestions(fields = [], typeLabel = 'this record') {
  const suggestions = [];
  const rows = Array.isArray(fields) ? fields : [];

  const statusField = findField(rows, (field) => (
    normalizeLabel(field?.key).includes('status') || normalizeLabel(field?.label).includes('status')
  ));

  if (statusField) {
    const completeOption = (Array.isArray(statusField?.enumOptions) ? statusField.enumOptions : [])
      .find((option) => normalizeLabel(option?.label).includes('onboard')
        || normalizeLabel(option?.label).includes('start')
        || normalizeLabel(option?.label).includes('progress'));

    const statusValue = cleanString(completeOption?.label || completeOption?.value || 'Onboarding Started');
    suggestions.push(`Set ${statusField.label} to ${statusValue}.`);
  }

  suggestions.push(`Create a follow-up record linked to ${typeLabel}.`);

  return suggestions
    .map((text) => cleanString(text))
    .filter(Boolean)
    .slice(0, 3);
}
